import { render, staticRenderFns } from "./FilterScriptaLanguageComponentDatatables.vue?vue&type=template&id=cf745d2a&scoped=true&"
import script from "./FilterScriptaLanguageComponentDatatables.vue?vue&type=script&lang=js&"
export * from "./FilterScriptaLanguageComponentDatatables.vue?vue&type=script&lang=js&"
import style0 from "./FilterScriptaLanguageComponentDatatables.vue?vue&type=style&index=0&id=cf745d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf745d2a",
  null
  
)

export default component.exports